import api from "../../Hooks/axiosApi";

export const createStageService = (data: any) => {
    return api.post('/api/Crm/createstages', data);
};

export const updateStageService = ({ stageID, data }: { stageID: any; data: any }) => {
    return api.put(`/api/Crm/updatestages/${stageID}`, data);
};

export const deleteStageService = (id: any) => {
    return api.delete(`/api/Crm/deletestages/${id}`);
};

export const getAllStagesService = () => {
    return api.get('/api/Crm/getAllstages');
};

export const getStageByIdService = (id: any) => {
    return api.get(`/api/Crm/getstageById/${id}`);
};
